import React, { memo } from 'react';
import { Text, Preset, Color } from '@lux/text';
import { Translate } from '@pegasus/translation';

import { Container } from './delivery-label.styles';

interface DeliveryLabelProps {
    message?: string;
    translationId?: string;
    hoverClassName?: string;
}

export const DeliveryLabel: React.FC<DeliveryLabelProps> = ({
    message,
    translationId,
    hoverClassName,
}) => {
    if ((!message || message.length === 0) && (!translationId || translationId.length === 0)) {
        return null;
    }

    return (
        <Container className={hoverClassName}>
            <Text preset={Preset.XS} color={Color.bright} uppercase>
                {translationId ? <Translate message={translationId} /> : message}
            </Text>
        </Container>
    );
};

export default memo(DeliveryLabel);
